<template>
  <v-row no-gutters full-width>
    <v-col cols="12">
      <style-dialog-style-rows :items="styleItems.service" v-model="currentStyle" style-type="style">
        <template #zoom="input">
          <style-dialog-zoom-input
            :inputBind="input"
            :minzoom.sync="currentStyle['minzoom']"
            :maxzoom.sync="currentStyle['maxzoom']"
          />
        </template>
      </style-dialog-style-rows>
    </v-col>
  </v-row>
</template>

<script>
import StyleDialogStyleRows from '@/components/StyleDialogStyleRows';
import StyleDialogZoomInput from '@/components/StyleDialogZoomInput';
import style from '@/mixins/style';

export default {
  name: 'ServiceLayerStyleContent',
  mixins: [style],
  components: {
    StyleDialogStyleRows,
    StyleDialogZoomInput,
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedIsValid() {
      return true;
    },
    currentStyle: {
      get() {
        return this.layer?.style;
      },
      set(nV) {
        this.layer.style = nV;
      },
    },
  },
  watch: {
    computedIsValid: {
      immediate: true,
      handler(nV) {
        this.$emit('update:isValid', nV);
      },
    },
  },
};
</script>
